/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetNewsItem200ResponseData } from './GetNewsItem200ResponseData'
import {
  GetNewsItem200ResponseDataFromJSON,
  GetNewsItem200ResponseDataFromJSONTyped,
  GetNewsItem200ResponseDataToJSON,
} from './GetNewsItem200ResponseData'

/**
 *
 * @export
 * @interface GetNewsItem200Response
 */
export interface GetNewsItem200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetNewsItem200Response
   */
  status: boolean
  /**
   *
   * @type {GetNewsItem200ResponseData}
   * @memberof GetNewsItem200Response
   */
  data: GetNewsItem200ResponseData
}

/**
 * Check if a given object implements the GetNewsItem200Response interface.
 */
export function instanceOfGetNewsItem200Response(
  value: object
): value is GetNewsItem200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetNewsItem200ResponseFromJSON(
  json: any
): GetNewsItem200Response {
  return GetNewsItem200ResponseFromJSONTyped(json, false)
}

export function GetNewsItem200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsItem200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetNewsItem200ResponseDataFromJSON(json['data']),
  }
}

export function GetNewsItem200ResponseToJSON(
  value?: GetNewsItem200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetNewsItem200ResponseDataToJSON(value['data']),
  }
}
